<template>
  <div class="py-2 rounded text-base" :class="colorClass">
    <div class="container flex gap-3 items-baseline">
      <i class=" text-lg" :class="iconClass"/>
      <div class="font-medium">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  variant: { type: String, default: "info" },
})

const colorClasses = {
  success: "bg-green-100 text-green-800",
  error: "bg-red-100 text-red-800",
  warning: "bg-yellow-100 text-yellow-800",
  info: "bg-blue-100 text-blue-800 dark:text-white",
}

const iconClasses = {
  success: "fa-solid fa-circle-check text-green-500",
  error: "fa-solid fa-circle-xmark text-red-500",
  warning: "fa-solid fa-circle-info text-yellow-500",
  info: "fa-solid fa-circle-info text-blue-500 dark:text-white",
}

const iconClass = computed(() => iconClasses[props.variant])
const colorClass = computed(() => colorClasses[props.variant])
</script>
